import { render, staticRenderFns } from "./ApplicantSelection.vue?vue&type=template&id=28db3c02&scoped=true"
import script from "./ApplicantSelection.vue?vue&type=script&lang=js"
export * from "./ApplicantSelection.vue?vue&type=script&lang=js"
import style0 from "./ApplicantSelection.vue?vue&type=style&index=0&id=28db3c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db3c02",
  null
  
)

export default component.exports